import { cloneElement, useEffect, useState } from "react";

interface IProps {
    children: React.ReactElement;
    interval: number,
}

export const Blinker: React.FC<IProps> = ({children, interval}) => {
    const [visible, setVisible] = useState<boolean>(true);

    useEffect(() => {
        const newInterval = setInterval(() => setVisible(!visible), interval);

        return () => window.clearInterval(newInterval)
    });

    return cloneElement(children, { style: { color: !visible && 'transparent' } })
}